<template>
    <div class="global-animated-icon">
        <div class="global-animated-icon__wrapper">
            <global-icon :theme="theme" :icon="iconInitial" />
            <global-icon :theme="theme" :icon="iconAnimate" />
            <global-icon :theme="theme" :icon="iconInitial"/>
        </div>
    </div>
</template>
<script>
import GlobalIcon from "@global/global-elements/global-icon/global-icon"

export default {
    name: 'global-animated-icon',
    components: {GlobalIcon},
    props: {
        iconInitial: String,
        iconAnimate: String,
        theme: {
            type: String,
            default: 'primary',
            validator: function(value) {
                return ['primary', 'secondary', 'brand', 'ghost'].indexOf(value) !== -1
            }
        },
    }
}
</script>
